import { factoryObserver } from '@maui-mf/splitio'
import env from '@maui-mf/env'
import { ready as authReady } from './auth-store'

const instance = { current: null }
const subscribers = []

export const start = async () => {
  const store = await authReady()
  const authorizationKey = env.SPLITIO_AUTHORIZATION_KEY
  const debug = env.SPLITIO_FACTORY_DEBUG === '1'

  if (!authorizationKey) {
    console.warn('splitio authorization key missing, factory observer cannot be started')
    return
  }

  // eslint-disable-next-line
  console.debug(`starting splitio factory observer, debug mode: ${debug}`)

  factoryObserver.init({
    core: {
      authorizationKey
    },
    urls: {
      sdk: 'https://featflgs-sdk.advantage.mandiant.com/api',
      events: 'https://featflgs-evt.advantage.mandiant.com/api',
      auth: 'https://featflgs-ath.advantage.mandiant.com/api',
      streaming: 'https://featflgs-str.advantage.mandiant.com',
      telemetry: 'https://featflgs-tel.advantage.mandiant.com/api',
    },
    debug
  })

  return new Promise(resolve => {
    const resolveOnce = (() => {
      let resolved = false
      return () => {
        if (!resolved) {
          resolved = true
          resolve()
        }
      }
    })()

    factoryObserver.subscribe(factory => {
      if (!factory) { return }

      const client = factory.client()
      const manager = factory.manager()
      const treatments = client.getTreatments(manager.names())
      const features = new Map()

      for (const treatment in treatments) {
        features.set(treatment, treatments[treatment] === 'on')
      }

      const current = instance.current
      instance.current = features

      const changed = current?.size !== features.size ||
        Array.from(features).some(([key, val]) => current.get(key) !== val)

      if (changed) {
        for (const subscriber of subscribers) {
          subscriber(instance.current)
        }
      }

      resolveOnce()
    })

    // If the user is already logged in, wait for the feature flags to be ready before
    // resolving. This allows the startup script to wait for complete feature flags for
    // a logged in user before building routes.
    if (!store.loggedIn()) {
      resolveOnce()
    }
  })
}

export const ready = () => !!instance.current
export const getMap = () => instance.current ? new Map(instance.current) : null
export const get = feature => instance.current?.get(feature) ?? false
export const subscribe = fn => {
  if (!subscribers.includes(fn)) {
    subscribers.push(fn)
  }

  const index = subscribers.indexOf(fn)

  return () => {
    subscribers.splice(index, 1)
  }
}

export const __teardown = () => {
  instance.current = null
  subscribers.length = 0
}
